<template>
  <div class="background-highlight">
    <div class="highlight" :class="propClass"></div>
  </div>
</template>
<script setup lang="ts">
defineProps<{
  propClass?: string
}>()
</script>
<style scoped lang="postcss">
.background-highlight {
  /*
  The highiligth effect div size is 640px with gradient blur of 100px.
  If we don't use overflow hidden in the parent it causes scroll when screen is < 640px.
  But the effect itself takes much more space and looks cut in the middle.
  That is why for the parent we use much bigger size tied to the screen size.
  Also we move the parent to the left by 1000px and add padding of 800px
  to emulate left: -200px 
  */
  @apply absolute -z-10 left-[-1000px] top-[-240px] overflow-x-hidden pl-[800px];
  width: calc(100vw + 1000px);
  /* on bigger screens calculated width causes scroll */
  max-width: 2000px;
  height: calc(100vh + 240px);
}

.highlight {
  @apply w-[640px] h-[640px] bg-accent-gradient rounded-full opacity-20 blur-[100px];
  /* Fixes blur in Safari */
  transform: translate3d(0, 0, 0);
}
</style>
